export const ACCOUNT_WEB_PAGES_RESET_STATE = 'ACCOUNT_WEB_PAGES_RESET_STATE';
export const ACCOUNT_WEB_PAGES_CURRENT_ITEM = 'ACCOUNT_WEB_PAGES_CURRENT_ITEM';

export const ACCOUNT_WEB_PAGES_REQUEST_LOADING = 'ACCOUNT_WEB_PAGES_REQUEST_LOADING';
export const ACCOUNT_WEB_PAGES_REQUEST_SUCCESS = 'ACCOUNT_WEB_PAGES_REQUEST_SUCCESS';
export const ACCOUNT_WEB_PAGES_REQUEST_FAILED = 'ACCOUNT_WEB_PAGES_REQUEST_FAILED';

export const ACCOUNT_WEB_PAGES_CURRENT_ACTION = 'ACCOUNT_WEB_PAGES_CURRENT_ACTION';
export const ACCOUNT_WEB_PAGES_RESET_ACTION = 'ACCOUNT_WEB_PAGES_RESET_ACTION';